// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ck-content span[style*=nowrap]{background-color:#ffab40!important}", "",{"version":3,"sources":["webpack://./src/plugins/NoBreak/NoBreak.css"],"names":[],"mappings":"AAAA,gCACE,kCACF","sourcesContent":[".ck-content span[style*=\"nowrap\"] {\r\n  background-color: #ffab40 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
